const HomeConfigurationIntegrated = ({language , token}) => {
    const newHomeConfigurationIframe = "https:" +
    window.process.env.URL_Home_Conf
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_homeConfiguration_display"
        src={newHomeConfigurationIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default HomeConfigurationIntegrated